import {Component} from "react";

class SidebarHeader extends Component {

    render() {
        return null;
    }
}

export default SidebarHeader;



// WEBPACK FOOTER //
// ./src/components/SidebarHeader/SidebarHeader.js